<template>
  <section id="contact-page">
    <!-- <div class="page-banner contact-banner hidden-sm-and-down">
      <div class="image">
        <img
          src="/img/page-banners/contact.png"
          alt="contact-page-banner"
          class="img-fluid"
        />
      </div>
    </div>-->
    <div class="section-pad">
      <!-- <div class="section-heading">
        <h3 class="text-center orange-color">How To Reach Us</h3>
      </div>-->
      <div class="section-content">
        <div class="google-map-iframe">
          <el-row>
            <el-col :lg="24" :sm="24" :xs="24">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2892.496409054218!2d172.63464481529945!3d-43.53369317912556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d318a3d47d3b525%3A0x9a4cdcce70e3cf07!2s678+Colombo+St%2C+Christchurch+Central+City%2C+Christchurch+8011%2C+New+Zealand!5e0!3m2!1sen!2sin!4v1566296452940!5m2!1sen!2sin"
                width="100%"
                height="400"
                frameborder="0"
                style="border:0"
                allowfullscreen
              ></iframe>
            </el-col>
          </el-row>
        </div>
        <div class="contact-form container">
          <el-row :gutter="0">
            <el-col :lg="10" :xs="24" :sm="10" :md="12">
              <div class="block-heading">
                <h3 class="title orange-color">Get In Touch</h3>
              </div>
              <div class="block-content">
                <el-form :model="contact_form" class="nutron-forms mb-20">
                  <el-row :gutter="20">
                    <el-col :lg="12" :xs="24">
                      <el-form-item label="Name">
                        <el-input v-model="contact_form.name" placeholder="Name"></el-input>
                        <small
                          v-if="getErrors && getErrors['name']"
                          class="invalid-feedback error"
                        >{{ getErrors['name'] }}</small>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :xs="24">
                      <el-form-item label="Email">
                        <el-input v-model="contact_form.email" placeholder="Email"></el-input>
                        <small
                          v-if="getErrors && getErrors['email']"
                          class="invalid-feedback error"
                        >{{ getErrors['email'] }}</small>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="24" :xs="24">
                      <el-form-item label="Subject">
                        <el-input v-model="contact_form.subject" placeholder="Subject"></el-input>
                        <small
                          v-if="getErrors && getErrors['subject']"
                          class="invalid-feedback error"
                        >{{ getErrors['subject'] }}</small>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="24" :xs="24">
                      <el-form-item label="Message">
                        <el-input
                          v-model="contact_form.message"
                          placeholder="Message"
                          type="textarea"
                          :rows="5"
                        ></el-input>
                        <small
                          v-if="getErrors && getErrors['message']"
                          class="invalid-feedback error"
                        >{{ getErrors['message'] }}</small>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="24" :xs="24">
                      <el-form-item class="mb0">
                        <el-button
                          type="primary"
                          @click="onSubmit"
                          :loading="loading"
                          class="btn submit-btn orange-bg orange-btn"
                        >Send</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-col>
            <el-col :lg="{span: 8, offset: 4}" :xs="{span: 24, offset: 0}" :sm="14" :md="12">
              <div class="block-heading">
                <h3 class="title orange-color">Contact Details</h3>
                <ul class="address-list">
                  <li>
                    <div class="icon-block">
                      <div class="icon">
                        <span class="el-icon-location-information"></span>
                      </div>
                      <div class="icon-text">
                        <p>
                          678 Colombo ST Christchurch Central,
                          <br />Christchurch 8011
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon-block">
                      <div class="icon">
                        <span class="el-icon-message"></span>
                      </div>
                      <div class="icon-text">
                        <p>colombo.store@nutron.co.nz</p>
                      </div>
                    </div>
                  </li>
                  <!-- <li>
                                        <div class="icon-block">
                                            <div class="icon">
                                                <span class="el-icon-mobile-phone"></span>
                                            </div>
                                            <div class="icon-text">
                                                <p>03 353 2232</p>
                                            </div>
                                        </div>
                  </li>-->
                  <li>
                    <div class="icon-block">
                      <div class="icon">
                        <span class="el-icon-timer"></span>
                      </div>
                      <div class="icon-text">
                        <p>Monday : 9:00 am - 5:30 pm</p>
                        <p>Saturday : 11:00 am - 3:00 pm</p>
                        <p>Sunday: closed</p>
                        <!-- <p>Sunday : 10 am - 4 pm</p> -->
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </section>
</template>

<!--<script src="https://unpkg.com/vee-validate@latest"></script>-->
<script>
import LayoutDefault from "@/layouts/LayoutDefault";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      contact_form: {
        name: "",
        email: "",
        subject: "",
        message: ""
      },

      submitted: false,
      showSuccess: false,
      showError: false,

      ownerData: {
        email: "sudhakar.i@orotron.com",
        name: "Sudhakar I"
      },
      formData: {
        form_title: "Contact Form",
        website_title: "Orotron",
        website_url: "http://orotron.com"
      },
      emailSubject: "Lead from the Website",
      successResponse: "Thank You, We will get back to you at the earliest",
      errorResponse: "Sorry! Unable to send your Message Now. Please try again",
      apiUrl:
        "https://z7inja5y3g.execute-api.ap-south-1.amazonaws.com/dev/notifications/email"
    };
  },
  created() {
    this.$emit("update:layout", LayoutDefault);
    this.$root.$emit('closenav', false);
  },
  computed: {
    ...mapGetters("errors", ["getMessage", "getErrors"])
  },

  methods: {
    async onSubmit() {
      this.loading = true;
      await this.$store.dispatch("contact/contact", this.contact_form);
      if (this.getMessage) {
        this.$message.success(this.getMessage);
        this.$store.commit("errors/clear");
        this.clearForm();
      }
      this.loading = false;
    },
    clearForm() {
      this.contact_form.name = "";
      this.contact_form.email = "";
      this.contact_form.subject = "";
      this.contact_form.message = "";
    }
  }
};
</script>

<style scoped lang="scss">
#contact-page {
  .section-content {
    padding: 0 2em;
  }

  .contact-form {
    margin-top: 45px;

    .el-form-item {
      margin-bottom: 2em;
    }

    .address-list {
      li:not(:last-child) {
        margin-bottom: 0.9em;
      }

      li {
        span {
          color: #767676;
          padding-top: 3px;
        }

        p {
          padding: 0;
          margin: 0;
          line-height: auto;
          color: #767676;
        }
      }
    }
  }
}
</style>
